<template>
    <div class="chart-container" style="position: relative; width:100%">
        <Line v-if="type === 'line'" :chart-data="chartData" :options="mergedOptions" />
        <Bar v-if="type === 'bar'" :chart-data="chartData" :options="mergedOptions" />
        <Pie v-if="type === 'pie'" :chart-data="chartData" :options="mergedOptions" />
        <Doughnut v-if="type === 'doughnut'" :chart-data="chartData" :options="mergedOptions" />
        <Radar v-if="type === 'radar'" :chart-data="chartData" :options="mergedOptions" />
    </div>
</template>

<script>
import { Bar, Line, Pie, Doughnut, Radar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, PointElement, LineElement, BarElement, ArcElement, CategoryScale, LinearScale, RadialLinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, PointElement, LineElement, BarElement, ArcElement, CategoryScale, LinearScale, RadialLinearScale)

export default {
    name: 'ChartWrapper',
    props: {
        type: { type: String, required: true },
        chartData: { type: Object, required: true },
        chartOptions: { type: Object, default: () => ({}) }
    },
    computed: {
        mergedOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                ...this.chartOptions
            }
        }
    },
    components: { Bar, Line, Pie, Doughnut, Radar }
}
</script>
